export { SignalRClient, defaultSignalRClient, DEFAULT_SIGNALR_URL } from "./signalr-client";
export { HeartbeatManager, createHeartbeatManager } from "./heartbeat";
export {
  connectionManager,
  ConnectionManager,
  EventDispatcher,
  realtimeConnectionManager,
  createConnectionManager,
} from "./connection-manager";
export {
  useConnectionStore,
  getConnectionHealth,
  type ConnectionLifecycleState,
  type ConnectionHealthSnapshot,
} from "./connection-store";
export {
  ConnectionStatusIndicator,
  RealtimeProvider,
  useConnection,
  useDeviceEvents,
  useGpsEvents,
} from "./connection-provider";

export type {
  DeviceOnlineEvent,
  DeviceOfflineEvent,
  GpsUpdatedEvent,
  CameraStatusChangedEvent,
  VehicleUpdatedEvent,
  PlaybackStatusEvent,
  RealtimeEvent,
  RealtimeEventType,
  EventHandler,
} from "./connection-manager";
